function env(name: string): string | undefined {
  const value = process.env[name];
  return value && value.trim() !== "" ? value : undefined;
}

export const URLS = {
  privacyPolicy:
    env("REACT_APP_PRIVACY_POLICY_URL") ??
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/villkor-och-regler/villkor-nar-du-reser-med-oss/hantering-av-personuppgifter",

  getReceipt:
    env("REACT_APP_GET_RECEIPT_URL") ??
    "https://www.ostgotatrafiken.se/biljetter/kopa-biljett/med-betalkort/kvitto-nar-du-blippat-betalkort/",

  resplusDelayCompensation: "https://forseningsersattning.resplus.se/?id=253",

  paratransitDelayCompensation:
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/forseningsersattning/forseningsersattning-for-fardtjanst-och-sjukresor",

  kalmarDelayCompensation:
    "https://kalmarlanstrafik.se/Kundservice/ansok-om-forseningsersattning/",

};
